module.exports = __webpack_public_path__ + "assets/img/ban-sign.d72291d9.png";